import { Column } from "../../../../core/components/Column";
import { SectionCard } from "../../../../core/components/SectionCard";
import { SocialMediaLinks } from "./SocialMediaLinks";

export interface Invitacion {
	nombre: string;
	imagen: string;
	redes_sociales?: string[];
}

export const CategoriesList = ({ categories }: { categories: Invitacion[] }) => {
	return (
		<Column
			crossAxisAlignment="center"
			className="py-5 px-5 gap-4 sm:gap-8"
		>
			<Column className="grid grid-cols-2 sm:grid-cols-3 w-full gap-4 sm:gap-8">
				{categories.map((categoria, index) => {
					return (
						<SectionCard
							key={index}
							index={index}
							img={categoria.imagen}
							titulo={categoria.nombre}
							responsive={true}
						>
							{categoria.redes_sociales && (
								<Column
									className="flex-grow w-full gap-2"
									mainAxisAlignment="end"
									crossAxisAlignment="center"
								>
									<SocialMediaLinks redesSociales={categoria.redes_sociales} />
								</Column>
							)}
						</SectionCard>
					);
				})}
			</Column>
		</Column>
	);
};
